import { AuthModel, UserModel } from "./_models";
import {api} from "../../../../api"
import { BASE_URL, CONFIRM, ERP_REGISTER, GET_ME, RESET_PASSWORD, TOKEN } from "app/api/URLs";
import axios from "axios";
import { JshirRegisterRequestConfirmProps } from "app/types/jshirregister";

// Server should return AuthModel
export function login(phone: string, password: string) {
  return api.post<AuthModel>(TOKEN, {
    phone,
    password,
  });
}

// Server should return AuthModel
export function register(
  jshir: any,
  phone: string,
  password: string,
  password_confirmation: string
) {
  const data = axios.post(`${BASE_URL}${ERP_REGISTER}`, {
    phone,
    jshir,
    password,
    password2: password_confirmation,
  });
  return data
}


export function reuqestErpConfirmPhone(otp: any, phone: any) {
  return axios.post<JshirRegisterRequestConfirmProps>(`${BASE_URL}${CONFIRM}`, {
    code: otp,
    phone,
    is_erp: true
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(phone: string) {
  return api.post<{ result: boolean }>(RESET_PASSWORD, {
    phone,
  });
}

export function getUserByToken() {
  return api.get<UserModel>(GET_ME);
}
